<script lang="ts">
	import { format } from 'date-fns';
	import { EventSlotStatus } from '$lib/eventSlotStatus';
	import { t } from '$lib/translations';
	import AlertWarning from '@icons/AlertWarning.svelte';
	import Icon from './Icon.svelte';

	export let registrationDeadline: Date;
	export let status: EventSlotStatus = EventSlotStatus.Open;

	const getStatusColor = (status: EventSlotStatus): string => {
		switch (status) {
			case EventSlotStatus.Open:
				return 'text-function-green';
			case EventSlotStatus.NonBookable:
				return 'text-function-green';
			case EventSlotStatus.AlmostFull:
				return 'text-function-green';
			case EventSlotStatus.Full:
				return 'text-secondary-orange-dark';
			case EventSlotStatus.Cancelled:
				return 'text-gray-1';
		}
	};
</script>

<div class="flex flex-col lg:gap-2.25 mb-3 lg:mb-0 lg:justify-center flex-grow">
	<div class="flex gap-1.5 items-center text-additional font-bold {getStatusColor(status)}">
		{#if status === EventSlotStatus.Cancelled}
			<Icon component={AlertWarning} class=" !w-4 !h-4 mr-1.5 inline-block" />
		{/if}
		<span>{$t(`common.slot_status.${status}`)}</span>
	</div>
	{#if status != EventSlotStatus.Cancelled}
		<div class="text-additional">
			{$t(`common.slot_status_subtext.${status}`, {
				date: format(registrationDeadline, 'dd.MM.yyyy')
			})}
		</div>
	{/if}
</div>
